import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav className="mb-4" aria-label="Breadcrumb">
      <div className="flex items-center space-x-2 text-sm">
        {items.map((item, index) => {
          // Generate a stable key based on item properties
          const key = `${item.label}-${item.href ?? 'text'}-${index}`;

          return (
            <React.Fragment key={key}>
              {index > 0 && <span className="text-gray-400">/</span>}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-secondary-500 hover:text-secondary-600 no-underline hover:underline"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-700">{item.label}</span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </nav>
  );
};
